import CardPacksEmpty from "components/placeholder-blocks/CardPacksEmpty";
import Loader from "components/Loader";
import Pagination from "components/Pagination";
import { useOutletContext } from "react-router-dom";
import MainContentLeft from "components/main-components/MainContentLeft";
import PageLoader from "components/page-components/PageLoader";
import { createContext, useState } from "react";
import CombineFail from "components/combine/CombineFail";
import useProfile from "hooks/useProfile";
import CombineList from "components/combine/CombineList";
import CombineSuccess from "components/combine/CombineSuccess";

export const CardPacksContext = createContext();

const CardPacks = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  const {errorText} = useProfile();
  const [selectedItems, setSelectedItems] = useState([])
  const [selectMode, setSelectMode] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <CardPacksContext.Provider value={{
      selectedItems,
      setSelectedItems,
      selectMode,
      setSelectMode,
      setIsSuccessVisible
    }}>
      <main className="main-content">
      <MainContentLeft
        getOpenedClass={getOpenedClass}
        filters={filters}
        setOffsetCount={setOffsetCount}
      />
      <div className="main-content__right">
        {isItemsLoading && !items.length ? (
          <Loader />
        ) : items.length ? (
          <>
            <CombineList items={items} />
            <Pagination
              offsetCount={offsetCount}
              setOffsetCount={setOffsetCount}
              paginationData={paginationData}
            />
          </>
        ) : (
          <CardPacksEmpty />
        )}
      </div>
    </main>

    {isSuccessVisible && <CombineSuccess close={() => setIsSuccessVisible(false)} />}
    {errorText !== null && <CombineFail errorText={errorText} />}
    </CardPacksContext.Provider>
  );
};

export default CardPacks;
